import { Lock } from 'lucide-react';

export default function FeatureBetaGate({ featureName = 'este módulo' }) {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[400px] bg-[#f0f4f8]">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-10 max-w-sm w-full mx-4 text-center">
        <div className="w-14 h-14 rounded-full bg-orange-50 flex items-center justify-center mx-auto mb-4">
          <Lock size={24} className="text-orange-400" />
        </div>
        <h2 className="text-lg font-semibold text-gray-800 mb-2">Beta fechado</h2>
        <p className="text-sm text-gray-500 leading-relaxed">
          {featureName === 'este módulo'
            ? 'Este módulo está em beta fechado.'
            : `O módulo "${featureName}" está em beta fechado.`}
          {' '}Aguarde a liberação pelo administrador.
        </p>
        <div className="mt-6 px-3 py-2 rounded-lg bg-orange-50 border border-orange-100">
          <p className="text-xs text-orange-600">
            Entre em contato com o administrador para solicitar acesso.
          </p>
        </div>
      </div>
    </div>
  );
}
